import request from './request'

//Para cada módulo crear un archivo con las requests necesarias, para exportarlas y llamarlas desde el componente correspondiente

export function crearOfertaMasDeNueve(oferta){
    return request({
        url:'/ofertas/masde9plazas',
        method:'POST',
        data: oferta,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function crearOfertaMenosDeNueve(oferta){
    return request({
        url:'/ofertas/menosde10plazas',
        method:'POST',
        data: oferta,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function modificarLoteOfertado(oferta){
    return request({
        url:'/ofertas/ + oferta.id',
        method:'PUT',
        data: oferta,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getAllOfertas(oferta){
    return request({
        url:'/ofertas',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getDetallesOferta(idOferta){
    return request({
        url:'/ofertas/' + idOferta,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function marcarNoJustificada(idOferta){
    return request({
        url:'/ofertas/noJustificarBaja/' + idOferta,
        method:'PUT',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function marcarSiJustificada(idOferta){
    return request({
        url:'/ofertas/justificarBaja/' + idOferta,
        method:'PUT',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function asignadoValidadoLoteOfertado(idOferta, idLote){
    return request({
        url:'/ofertas/asignadoValidadoLote/' + idOferta,
        method:'PUT',
        data: {
            idLote: idLote
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function asignadoPdteValidarLoteOfertado(idOferta, idLote){
    return request({
        url:'/ofertas/asignarPdteValidarLote/' + idOferta,
        method:'PUT',
        data: {
            idLote: idLote
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function asignadoPdteSubsanacionLoteOfertado(idOferta, idLote){
    return request({
        url:'/ofertas/asignarPdteSubsanacionLote/' + idOferta,
        method:'PUT',
        data: {
            idLote: idLote
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function adjudicarLote(idOferta, idLote){
    return request({
        url:'/ofertas/adjudicarLote/' + idOferta,
        method:'PUT',
        data: {
            idLote: idLote
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function quitarLote(idOferta, idLote){
    return request({
        url:'/ofertas/quitarLote/' + idOferta,
        method:'PUT',
        data: {
            idLote: idLote
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function excluirOferta(motivoOferta, idOferta){
    return request({
        url:'/ofertas/excluir/' + idOferta,
        method:'PUT',
        data: {
            motivoExclusion: motivoOferta
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}